import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=876ab25a&scoped=true&"
import script from "./Debug.vue?vue&type=script&lang=js&"
export * from "./Debug.vue?vue&type=script&lang=js&"
import style0 from "./Debug.vue?vue&type=style&index=0&id=876ab25a&prod&lang=scss&scoped=true&"
import style1 from "./Debug.vue?vue&type=style&index=1&id=876ab25a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876ab25a",
  null
  
)

export default component.exports